import { Component, OnInit, Input } from '@angular/core';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
declare const $: any;

@Component({
  selector: 'app-image-control',
  templateUrl: './image-control.component.html',
  styleUrls: ['./image-control.component.css'],
})
export class ImageControlComponent implements OnInit {
  @Input() imageName: string;
  @Input() imagePath: string;
  @Input() imageRedirectURL: string;
  @Input() imageCaption: string;
  @Input() isQuestionImage: boolean = false;

  ImageAlt: string;
  productName: string = '';

  constructor(private service: ParticipationDataService) { }

  ngOnInit() {
    this.productName = this.service.getProductName();
    if (this.imageCaption != undefined && this.imageCaption != '') {
      this.ImageAlt = this.imageCaption;
    } else {
      if (this.imagePath != undefined) {
        let imageAltText = this.imageName.split('.');

        imageAltText[0] = imageAltText[0].replace(/[$%-]/g, '_');

        if (imageAltText.length > 0) {
          let imageText = imageAltText[0].split('_');
          if (imageText.length > 0) {
            this.ImageAlt = imageText[0];
          } else {
            this.ImageAlt = imageAltText[0];
          }
        } else this.ImageAlt = 'Answer Image';
      } else {
        this.ImageAlt = 'Survey Logo';
      }
    }
    if (this.imagePath != undefined) {
      this.imageName = this.imagePath + this.imageName;
    }
  }

  setScroll() {
    let self = this;
  }
}
